/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table } from "antd";
import isEmpty from "lodash/isEmpty";

const Datatable = ({ props, columns, dataSource, footerTotals,decimalpoints,pagination}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Table
      key={props}
      className="table datanew dataTable no-footer"
      // rowSelection={rowSelection}
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      // pagination={{
      //   showTotal: (total, range) =>
      //     `${range[0]}-${range[1]} of ${total} items`,
      // }}
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      }}
      summary={() => {
        return (
          <Table.Summary>
            {console.log(footerTotals)}
            {!isEmpty(footerTotals) && (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={1}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                {columns.slice(1).map((col, index) => {
                  return (
                    <Table.Summary.Cell key={index} index={index + 1}>
                      {footerTotals[col.dataIndex]?.toFixed(decimalpoints) || ""}
                    </Table.Summary.Cell>
                  );
                })}
              </Table.Summary.Row>
            )}
          </Table.Summary>
        );
      }}
    />
  );
};

export default Datatable;
